<template>
  <div class="conten">
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true">
        <el-form-item>
          <el-input clearable v-model="secah.fullName" placeholder="请输入客户昵称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-input clearable v-model.number="secah.tel" placeholder="请输入客户手机号"></el-input>
        </el-form-item>

        <el-form-item>
          <el-select v-model="secah.isCertification" placeholder="请选择订单类型" clearable>
            <el-option label="申请中" :value="2">
            </el-option>
            <el-option label="已通过" :value="3">
            </el-option>
            <el-option label="已拒绝" :value="4">
            </el-option>
          </el-select>

        </el-form-item>

        <el-form-item>
          <el-button @click='secahClick'>搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button @click='fenhongShow = true'>jks绩效券分红</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <div>
      <el-table :data="tableData" style="width: 100%" border>
        <el-table-column prop="fullName" label="昵称" align="center">
        </el-table-column>
        <el-table-column prop="tel" label="电话" align="center">
        </el-table-column>
        <el-table-column prop="tel" label="是否实名认证" align="center">
          <template slot-scope="scope">{{scope.row.isCertification==3?"是":"否"}}</template>
        </el-table-column>
        <el-table-column prop="tel" label="实名认证状态" align="center">
          <template slot-scope="scope">{{scope.row.isCertification==1?"未申请":scope.row.isCertification==2?"申请中":scope.row.isCertification==3?"已通过":"已拒绝"}}</template>
        </el-table-column>
        <el-table-column prop="tel" label="用户等级" align="center">
          <template slot-scope="scope">{{getUserLevel(scope.row.appUserLevel)}}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" align="center">
        </el-table-column>
        <el-table-column prop="lastLoginDate" label="最后一次登录时间" align="center">
        </el-table-column>
        <el-table-column fixed="right" label="操作" width="280" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.isCertification==2" style="margin-bottom: 10px;">
              <el-button type="success" size="mini" @click="agreeCertification(scope.row)">通过实名认证
              </el-button>
              <el-button type="danger" size="mini" @click="refuseCertification(scope.row)">拒绝通过实名认证
              </el-button>
            </div>
            <div style="margin-bottom: 10px;">
              <el-button type="primary" size="mini" @click="showUserLevel(scope.row)">设置用户等级</el-button>
            </div>
            <div style="margin-bottom: 10px;">
              <el-button type="primary" v-if="scope.row.operationLevel!=4" size="mini" @click="setYys(scope.row, 4)">设为技术运营商</el-button>
              <el-button type="primary" v-if="scope.row.operationLevel!=5" size="mini" @click="setYys(scope.row, 5)">设为核心运营商</el-button>
            </div>

            <el-button size="mini" @click="details(scope.row)">详情</el-button>
            <el-button size="mini" v-if="scope.row.enableStatus==2" type="success" @click="isEnable(scope.row)">启用</el-button>
            <el-button size="mini" v-else type="warning" @click="isEnable(scope.row)">禁用</el-button>

          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="secah.pageNum" :page-sizes="[10, 20, 50, 100]" :page-size="secah.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="客户详情" :visible.sync="dialogVisible" :modal-append-to-body='false' width="600px">
      <el-descriptions title="用户信息" :column='2'>
        <el-descriptions-item label="用户昵称">{{detailsData.fullName}}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{detailsData.tel}}</el-descriptions-item>
        <el-descriptions-item label="创建时间">{{detailsData.createTime}}</el-descriptions-item>
        <el-descriptions-item label="最后一次登录时间">{{detailsData.lastLoginDate}}</el-descriptions-item>
        <el-descriptions-item label="抵扣余额">{{detailsData.discount}}</el-descriptions-item>
        <el-descriptions-item label="邀请人电话">{{detailsData.invitationTel}}</el-descriptions-item>
        <el-descriptions-item label="jkc券">{{detailsData.jkcMoney}}</el-descriptions-item>
        <el-descriptions-item label="jks股权">{{detailsData.jksShares}}</el-descriptions-item>
        <el-descriptions-item label="bps分润值">{{detailsData.bpsBean}}</el-descriptions-item>
        <el-descriptions-item label="贡献值">{{detailsData.contributionValue}}</el-descriptions-item>
        <el-descriptions-item label="绩效分">{{detailsData.entrepreneurialPerformanceScore}}</el-descriptions-item>
        <el-descriptions-item label="当月贡献值">{{detailsData.monthContributionValue}}</el-descriptions-item>
        <el-descriptions-item label="有效积分">{{detailsData.onLineIntegral}}</el-descriptions-item>
        <el-descriptions-item label="冻结积分">{{detailsData.offLineIntegral}}</el-descriptions-item>
        <el-descriptions-item label="业绩">{{detailsData.performance}}</el-descriptions-item>
        <el-descriptions-item label="钱包">{{detailsData.wallet}}</el-descriptions-item>

        <el-descriptions-item label="是否实名认证">{{detailsData.isCertification==3?"是":"否"}}</el-descriptions-item>
        <el-descriptions-item label="实名认证状态">
          {{detailsData.isCertification==1?"未申请":detailsData.isCertification==2?"申请中":detailsData.isCertification==3?"已通过":"已拒绝"}}
        </el-descriptions-item>
        <el-descriptions-item label="姓名">{{detailsData.fullName}}</el-descriptions-item>
        <el-descriptions-item label="身份证号">{{detailsData.idCard}}</el-descriptions-item>
      </el-descriptions>
      <div style="display: flex;" v-if="detailsData.idCardFront">
        <div style="flex: 1;display: flex;">
          <span> 身份证正面</span>
          <viewer>
            <img :src="webUrl+detailsData.idCardFront" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>

        </div>
        <div style="flex: 1;display: flex;">
          <span> 身份证反面</span>
          <viewer>
            <img :src="webUrl+detailsData.idCardBack" style="width: 150px;height: 120px;margin-left: 10px;" />
          </viewer>
        </div>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="拒绝原因" :visible.sync="isreason" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="拒绝原因" label-width='80px'>
          <el-input type="textarea" v-model="refuseReason" maxlength="10" autocomplete="off" placeholder="请输入拒绝原因"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isreason = false">取 消</el-button>
        <el-button type="primary" @click="sub">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' :title="yysTitle" :visible.sync="yysShow" :modal-append-to-body='false' width="600px">
      <el-form>
        <!-- <el-form-item label="身份证正面" label-width='100px'>
          <el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'" :headers="headers" accept=".png,.jpg" :on-error='onError' :show-file-list="false" :on-success="setSfzZm">
            <img v-if="setyysInfo.idCardPositive" :src="webUrl+setyysInfo.idCardPositive" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="身份证反面" label-width='100px'>
          <el-upload class="avatar-uploader" :action="upImg+'/file/upload/pic'" :headers="headers" accept=".png,.jpg" :on-error='onError' :show-file-list="false" :on-success="setSfzFm">
            <img v-if="setyysInfo.idCardNegative" :src="webUrl+setyysInfo.idCardNegative" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="yysShow = false">取 消</el-button>
        <el-button type="primary" @click="setyysConfirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="jks绩效券分红" :visible.sync="fenhongShow" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="分红总金额" label-width='120px'>
          <el-input type="text" v-model="shareBonusAmount" maxlength="10" autocomplete="off" placeholder="请输入分红总金额">
          </el-input>
        </el-form-item>
        <el-form-item label="分红密码" label-width='120px'>
          <el-input type="password" v-model="password" maxlength="10" autocomplete="off" placeholder="请输入分红密码">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="fenhongShow = false">取 消</el-button>
        <el-button type="primary" @click="fenhong()">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog :close-on-click-modal='false' :close-on-press-escape='false' title="设置用户等级" :visible.sync="showSetUserLevel" :modal-append-to-body='false' width="600px">
      <el-form>
        <el-form-item label="等级" label-width='80px'>
          <el-select v-model="selectItem.appUserLevel" placeholder="请选择等级" clearable>
            <el-option label="V4创业合伙人" :value="4">
            </el-option>
            <el-option label="V5运营合伙人" :value="5">
            </el-option>
            <el-option label="V6渠道合伙人" :value="6">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="showSetUserLevel = false">取 消</el-button>
        <el-button type="primary" @click="setUserLevel">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data() {
    return {
      tableData: [],
      total: 0,
      dialogVisible: false,
      secah: {
        pageSize: 10,
        pageNum: 1,
        fullName: '',
        tel: '',
        isCertification: '',
      },
      detailsData: {},
      isreason: false,
      appUserId: '',
      refuseReason: '',
      yysTitle: '',
      yysShow: false,
      headers:{
        'token':this.$store.state.token,
        // 'Content-Type': 'multipart/form-data'
      },
      setyysInfo: {
        appUserId: '',
        level: '',
        phone: '',
      },
      fenhongShow: false,
      password: '',
      shareBonusAmount: '',
      showSetUserLevel: false,
      selectItem: {}
    }
  },
  created() {
    this.getCustomerList()
  },
  methods: {
    getUserLevel(appUserLevel) {
      if(appUserLevel == 1) {
        return 'V1普通合伙人'
      } else if(appUserLevel == 2) {
        return 'V2分润合伙人'
      } else if(appUserLevel == 3) {
        return 'V3贡献合伙人'
      } else if(appUserLevel == 4) {
        return 'V4创业合伙人'
      } else if(appUserLevel == 5) {
        return 'V5运营合伙人'
      } else if(appUserLevel == 6) {
        return 'V6渠道合伙人'
      }
    },
    showUserLevel(item) {
      console.log(item)
      this.showSetUserLevel = true
      this.selectItem = JSON.parse(JSON.stringify(item))
      if(this.selectItem.appUserLevel != 4 || this.selectItem.appUserLevel != 5 || this.selectItem.appUserLevel != 6) {
        this.selectItem.appUserLevel = ''
      }
    },
    setUserLevel() {
      let params = {
        "appUserId": this.selectItem.appUserId,
	      "level": this.selectItem.appUserLevel
      }
      this.httpPost('/appUser/setAppUserLevel', params, true, {
        'Content-Type': 'application/json',
      }).then(
        (res) => {
          if (res.code == 200) {
            this.showSetUserLevel = false
            this.getCustomerList()
          }
        }
      )
    },
    //搜索
    secahClick() {
      this.secah.pageNum = 1
      if (!this.isNullNum(this.secah.tel)) {
        this.$message('请输入正确的电话号码')
      }
      this.getCustomerList()
    },
    //详情
    details(row) {
      this.httpPost('/appUser/detail?appUserId=' + row.appUserId).then(
        (res) => {
          if (res.code == 200) {
            this.dialogVisible = true
            this.detailsData = res.data
          }
        }
      )
    },
    //通过实名认证
    agreeCertification(row) {
      this.$confirm('确定通过当前账号实名认证?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/appUser/agreeCertification?appUserId=' + row.appUserId
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('操作成功')
              this.dialogVisible = false
              this.getCustomerList()
              // this.getUserList()
            }
          })
        })
        .catch(() => {})
    },
    //拒绝通过实名认证
    refuseCertification(row) {
      this.isreason = true
      this.appUserId = row.appUserId
    },
    //确定拒绝通过实名认证
    sub() {
      this.httpPost(
        '/appUser/refuseCertification?appUserId=' +
          this.appUserId +
          '&refuseReason=' +
          this.refuseReason
      ).then((res) => {
        if (res.code == 200) {
          this.$message.success('操作成功')
          this.isreason = false
          this.getCustomerList()
          // this.getUserList()
        }
      })
    },
    //启用禁用
    isEnable(row) {
      row.enableStatus = row.enableStatus == 1 ? 2 : 1
      this.httpPut('appUser/update', row, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success('修改成功')
          this.dialogVisible = false
          // this.getUserList()
        }
      })
    },
    fenhong() {
      if(!this.password || !this.shareBonusAmount) {
        this.$message.error('请完善信息')
        return
      }
      let params = {
        password: this.password,
        shareBonusAmount: this.shareBonusAmount
      }
      this.$confirm('确定分红吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          this.httpPost(
            '/system/user/shareOutBonus', params, true, {'Content-Type':'application/json'}
          ).then((res) => {
            if (res.code == 200) {
              this.$message.success('分红成功')
              this.fenhongShow = false
            }
          })
        })
        .catch(() => {})
    },
    //上传封面图片回调
    setSfzZm(res, file) {
      this.setyysInfo.idCardPositive = res.data.path
    },
    setSfzFm(res, file) {
      this.setyysInfo.idCardNegative = res.data.path
    },
    onError(){
      this.$message.error("上传失败")
    },
    setYys(row, level) {
      // this.setyysInfo.appUserId = '';
      // this.setyysInfo.level = '';
      // this.setyysInfo.phone = '';
      // this.setyysInfo.idCardPositive = '';
      // this.setyysInfo.idCardNegative = '';

      // this.yysTitle =
      //   '设为' + (level == 4 ? '技术' : level == 5 ? '核心' : '') + '运营商'
      // this.yysShow = true
      // this.yysType = level
      this.setyysInfo.appUserId = row.appUserId
      this.setyysInfo.level = level
      this.setyysInfo.phone = row.tel

      this.setyysConfirm()
    },
    setyysConfirm() {
      // if(!this.setyysInfo.idCardPositive || !this.setyysInfo.idCardNegative) {
      //   this.$message.error('请完善信息')
      //   return
      // }
      this.$confirm(
        '确定设置当前帐号为' +
          (this.setyysInfo.level == 4 ? '技术' : this.setyysInfo.level == 5 ? '核心' : '') +
          '运营商?',
        '提示',
        {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
        }
      ).then(() => {
        this.httpPost('/appUser/setOperationPartner', this.setyysInfo, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
          if (res.code == 200) {
            this.$message.success('操作成功')
            this.getCustomerList()
            this.yysShow = false
          }
        })
      })
    },
    //选择分页条数
    handleSizeChange(e) {
      this.secah.pageNum = 1
      this.secah.pageSize = e
      this.getCustomerList()
    },
    //页码
    handleCurrentChange(e) {
      this.secah.pageNum = e
      this.getCustomerList()
    },
    //获取数据
    getCustomerList() {
      this.httpPost('/appUser/listByPage', this.secah, true, {
        'Content-Type': 'application/json',
      }).then((res) => {
        console.log(res)
        if (res.code == 200) {
          this.tableData = res.data.content
          this.total = res.data.total
        }
      })
    },
  },
}
</script>

<style scoped lang='scss'>
.page {
  padding: 20px 0;
}
::v-deep .viewer-container {
  z-index: 100000000000;
}
</style>
